export default __webpack_public_path__ + "static/media/prepare-execute.d40d8b57.svg";